var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { API } from './api';
import { UserProvider } from './user';
import { BaseProvider } from './base';
import bugsnag from 'bugsnag-js';
import { OnPremiseProvider } from './on-premise';
var bugsnagClient = null;
var BugsnagProvider = /** @class */ (function (_super) {
    __extends(BugsnagProvider, _super);
    function BugsnagProvider(userProvider, api, onPremiseProvider) {
        var _this = _super.call(this) || this;
        _this.userProvider = userProvider;
        _this.api = api;
        _this.onPremiseProvider = onPremiseProvider;
        if (!_this.onPremiseProvider.isOnPremiseElectronApp()) {
            bugsnagClient = bugsnag({
                apiKey: '3d71819272146b851d8637ce1a37a39a',
                releaseStage: _this.api.getEnvironment()
            });
            bugsnagClient.user = {
                email: _this.userProvider.getUserInformation().email,
                token: _this.api.getWheatleyToken()
            };
        }
        return _this;
    }
    /**
     * Helper function to expose the bugsnag.notify() functionality
     * @see https://docs.bugsnag.com/platforms/javascript/reporting-handled-errors/
     *
     * @param payload the error object we're sending to bugsnag
     * @param opts (optional) any additional parameters that need to be passed to bugsnag
     *
     * @return void
     */
    BugsnagProvider.prototype.logError = function (payload, opts) {
        if (opts === void 0) { opts = {}; }
        if (bugsnagClient && !this.onPremiseProvider.isOnPremiseElectronApp()) {
            try {
                bugsnagClient.notify(payload, opts);
            }
            catch (e) {
                console.log('Could not contact BugSnag services:', e);
            }
        }
    };
    /**
     * Helper function to log to bugsnag at an info level
     *
     * @param payload the info object we're logging to bugsnag
     *
     * @return void
     */
    BugsnagProvider.prototype.logInfo = function (payload) {
        if (bugsnagClient && !this.onPremiseProvider.isOnPremiseElectronApp()) {
            try {
                bugsnagClient.notify("INFO: " + payload, { severity: 'info' });
                console.log(payload);
            }
            catch (e) {
                console.log('Could not contact BugSnag services:', e);
            }
        }
    };
    BugsnagProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [UserProvider, API, OnPremiseProvider])
    ], BugsnagProvider);
    return BugsnagProvider;
}(BaseProvider));
export { BugsnagProvider };
//# sourceMappingURL=bugsnag.js.map


// WEBPACK FOOTER //
// ./src/providers/bugsnag.ts.pre-build-optimizer.js